import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Outlet, useParams } from 'react-router-dom'
import { useQuery } from 'modules/core/hooks/useQuery'
import { UniversalUpdaterContractsDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalUpdaterContractsPage = () => {
  const { company, access } = useCurrentSession()
  const { legal_entity_id: legalEntityId } = useParams<{ legal_entity_id?: string }>()
  const { data, loading, error } = useQuery(UniversalUpdaterContractsDocument, {
    variables: { companyId: company.id, legalEntityId: String(legalEntityId) },
    fetchPolicy: 'network-only',
    skip: !legalEntityId,
  })

  const hasDevUniversalUpdaterFeature =
    data?.features.featuresConnection.edges.find(
      (feature) => feature.node.name === 'dev_universal_updater_employees'
    )?.node.enabled ?? false
  const canImportResources = data?.universalImporter._policies.importResources.can ?? false
  const isAuthorized = hasDevUniversalUpdaterFeature && canImportResources

  const locale = access.locale
  const legalEntityCountry = data?.companies.legalEntitiesConnection.nodes[0]?.country
  const metadata = {
    legal_entity_ids: legalEntityId ? [BigInt(legalEntityId)] : [],
    legal_entity_countries: legalEntityCountry ? [legalEntityCountry] : [],
  }

  return (
    <ResponsivePage.Body
      authorized={isAuthorized}
      loading={loading}
      error={error}
      showHeader={false}
    >
      <NuvoImporter
        importType="contract_version_edition"
        locale={locale}
        companyId={company.id}
        metadata={metadata}
        useFileUploadInEdition
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default UniversalUpdaterContractsPage
